/**
 * An object representing a sponsor
 * @property {string} id The SAP account id of the sponsor
 * @property {string} firstName The first name for the sponsor (deprecated)
 * @property {string} lastName The last name for the sponsor (deprecated)
 * @property {string} displayName The sponsor's display name
 * @property {string} profileImageUrl The profile image url
 */
export default class Sponsor {
    /** @constructor */
    constructor({
        id,
        firstName,
        lastName,
        displayName,
        profileImageUrl
    }) {
        this.id = id;
        this.firstName = firstName;
        this.lastName = lastName;
        this.displayName = displayName;
        this.profileImageUrl = profileImageUrl;
    }
}
